import { useEffect, useRef } from "react";
import { useAuth } from "../hooks/useAuth";
import {
  publishFriendRequestNotification,
  subscribePendingFriendRequestsForUser,
} from "../services/playerRelationshipService";

/**
 * Backfill pending friend requests into durable inbox (deduped by relationship id).
 */
export default function FriendRequestNotificationSync() {
  const { uid, isAuthenticated } = useAuth();
  const seenRef = useRef(new Set());

  useEffect(() => {
    if (!isAuthenticated || !uid) return undefined;

    return subscribePendingFriendRequestsForUser(uid, (list) => {
      (list || []).forEach((rel) => {
        const id = rel?.relationshipId;
        if (!id || seenRef.current.has(id)) return;
        seenRef.current.add(id);
        void publishFriendRequestNotification(rel, uid);
      });
    });
  }, [isAuthenticated, uid]);

  return null;
}
